module.exports = __webpack_public_path__ + "img/quanshang.6eee5bab.png";